import svg from './row-svg/compte.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CompteIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CompteIcon;
